<template>
  <div class="ghost-button-styles">
    <Moduler name="a" title="基础信息">
      <BasicPlanInfo ref="gdt-v3-form-basic" v-model="planForm" class="disable-plan-form">
        <el-form-item label="账号选择" prop="accounts">
          <el-select style="width: 320px" v-model="planForm.accounts[0]" filterable clearable placeholder="请选择投放账号">
            <el-option v-for="item in accountList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </BasicPlanInfo>
    </Moduler>

    <Moduler name="a" title="营销目标及场景">
      <MaketingGoal v-model="planForm" class="disable-plan-form"></MaketingGoal>
    </Moduler>

    <Moduler name="a" title="计划版位">
      <Siteset v-model="planForm" class="disable-plan-form"></Siteset>
    </Moduler>

    <Moduler name="a" title="定向">
      <Targeting
        v-if="planForm.accounts.length && targetingForm.name"
        :ad-marketing-scene="planForm.ad_marketing_scene"
        v-model="targetingForm"
        :is-edit-mode="true"
      ></Targeting>
    </Moduler>

    <Moduler name="a" title="排期及预算" v-if="budgetForm">
      <BudgetBid v-model="budgetForm" :plan-form="planForm" ref="gdt-v3-form-bid">
        <template v-slot:daterange>
          <el-form-item label="投放时间">
            <el-date-picker
              v-model="budgetForm.rangeDate"
              :picker-options="{ disabledDate: (date) => date && date.valueOf() < Date.now() - 1000 * 60 * 60 * 24 }"
              type="daterange"
              range-separator="~"
              style="width: 292px"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template v-slot:materialTags>
          <el-form-item label="投放素材标签（选填）">
            <div class="material-tags">
              <el-select v-model="budgetForm.material_package_id" disabled>
                <el-option v-for="item in materialTagList" :key="item.label_id" :label="item.label_name" :value="item.label_id">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </template>
      </BudgetBid>
    </Moduler>

    <div class="submit-row">
      <el-button type="primary" @click="onPlanUpdateSubmit" :loading="submitLoading">确认提交</el-button>
    </div>
  </div>
</template>

<script>
import Moduler from '@/components/moduler'
import BasicPlanInfo from '../components/plan/basic.vue'
import MaketingGoal from './components/plan/maketing-goal.vue'
import Siteset from '../components/plan/siteset.vue'
import Targeting from '../components/target/index.vue'
import BudgetBid from '../components/budget/index.vue'

import { getV3UpdatePlanForm, getV3PlanForm, getV3UpdateTargetingForm, getV3UpdateBudgetForm } from '../model/project-form.js'
import { makeV3OuterPlanParams } from '../model/distribute-form.js'
import { adAccount } from '@/api/common.model'
import { getMaterialTags } from '@/api/tencent.model'
import { getTencentV3AdInfo, updateTencentV3Plan } from '@/api/tencentada.model.js'
import { projectComputedMethods } from '../model/project-mixins.js'
let regionList = []

fetch('/data/tencent_region.json')
  .then((res) => res.json())
  .then((data) => {
    regionList = data
  })
export default {
  components: { Moduler, BasicPlanInfo, MaketingGoal, Siteset, Targeting, BudgetBid },
  provide() {
    return {
      projectInstance: this
    }
  },
  data() {
    return {
      planForm: getV3PlanForm(),
      targetingForm: {},
      budgetForm: null,
      accountList: [],
      materialTagList: [],
      submitLoading: false
    }
  },
  computed: {
    ...projectComputedMethods
  },
  created() {
    this.getPageData()
  },
  methods: {
    /**
     * @description: 提交计划单条修改
     */
    onPlanUpdateSubmit() {
      const { accountId, projectId } = this.$route.query || {}
      try {
        this.submitLoading = true
        const params = makeV3OuterPlanParams({ plan: this.planForm, bid: this.budgetForm, target: this.targetingForm }, regionList)

        // 删除定向名称
        const { targetingName, ...targeting } = params.targeting
        const planParams = {
          ...params,
          targeting,
          account_id: accountId,
          adgroup_id: projectId
        }
        updateTencentV3Plan(planParams).then((data) => {
          if (data) {
            this.$Message.success('提交成功，2秒后自动关闭页面')
            setTimeout(() => {
              window.close()
            }, 2000)
          } else {
            this.submitLoading = false
          }
        })
      } catch (e) {
        console.log('submit error output: ', e)
        e?.message && this.$Message.error(e.message)
        this.submitLoading = false
      }
    },
    /**
     * @description: 回显计划单条修改表单，从媒体获取广告计划信息
     */
    async getPlanInfo() {
      const { accountId, projectId } = this.$route.query || {}
      if (accountId && projectId) {
        try {
          const info = await getTencentV3AdInfo({ accountId, projectId })
          if (info.out_plan_info && info.plan_info) {
            const planForm = getV3UpdatePlanForm(info)
            this.planForm = planForm

            // 等待账号计算属性更新
            await this.$nextTick()

            this.targetingForm = getV3UpdateTargetingForm.call(this, info)

            this.budgetForm = getV3UpdateBudgetForm(info)
          }
        } catch (e) {
          console.log('getTencentV3AdInfo error output: ', e)
        }
      }
    },

    getPageData() {
      const { accountId, mediaId } = this.$route.query || {}
      // 获取账号列表
      adAccount({ mediaId, authFlag: 1 }).then((data) => {
        this.accountList = data.map((d) => ({ ...d, value: d.name }))
        this.getPlanInfo()
      })

      // 获取素材标签
      getMaterialTags({ ad_account_id: accountId }).then((data) => {
        this.materialTagList = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.disable-plan-form {
  position: relative;
  z-index: 1;

  &:before {
    width: 100%;
    height: calc(100% + 40px);
    content: ' ';
    position: absolute;
    margin-top: -20px;
    margin-bottom: -20px;
    background-color: rgba(88, 88, 88, 0.04);
    cursor: not-allowed;
    z-index: 2;
  }
}
.submit-row {
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 10;
  border: 1px solid #eaeaea;
  text-align: right;
  padding: 12px;
  background-color: #fff;
}
</style>
